import { ArrayValues } from 'type-fest';

import { Sizes } from '../../../../types';

export const tendencyIconVariants = ['arrow', 'caret'] as const;
export type TendencyIconVariant = ArrayValues<typeof tendencyIconVariants>;

export const tendencyIconSizes = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export type TendencyIconSize = Sizes<ArrayValues<typeof tendencyIconSizes>>;

export const tendencyIconSizePxMap: Record<TendencyIconSize, number> = {
  xs: 8,
  sm: 10,
  md: 12,
  lg: 14,
  xl: 16,
};
